/* GP STORE global JS */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toast = document.createElement('div');
  toast.className = 'toast';
  document.body.appendChild(toast);
  var toastTimer;
  window.gpToast = function (msg) {
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
  };

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    var idx = 0, timer;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function auto() { timer = setInterval(function () { go(idx + 1); }, 5500); }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { clearInterval(timer); go(i); auto(); });
    });
    auto();
  });

  /* ---------- Deals countdown (to midnight) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      if (h) h.textContent = String(Math.floor(diff / 3600)).padStart(2, '0');
      if (m) m.textContent = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
      if (s) s.textContent = String(diff % 60).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Scroll reveal (with fail-safe) ---------- */
  try {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } catch (err) { /* fall through to fail-safe */ }
  // Fail-safe: never leave content hidden if the observer doesn't fire
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) { el.classList.add('is-visible'); });
  }, 1800);

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('.mobile-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      drawer && drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
    });
  });
  overlay && overlay.addEventListener('click', function () {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'gp_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWish(list) {
    localStorage.setItem(WKEY, JSON.stringify(list));
    updateWishCount();
  }
  function updateWishCount() {
    var n = getWish().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? 'grid' : 'none';
    });
  }
  window.gpWishlist = { get: getWish, set: setWish };
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-wish-handle]');
    if (!btn) return;
    ev.preventDefault();
    var handle = btn.getAttribute('data-wish-handle');
    var list = getWish();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); btn.classList.remove('is-wished'); gpToast('Removed from wishlist'); }
    else { list.push(handle); btn.classList.add('is-wished'); gpToast('❤ Added to wishlist'); }
    setWish(list);
  });
  function markWished() {
    var list = getWish();
    document.querySelectorAll('[data-wish-handle]').forEach(function (b) {
      b.classList.toggle('is-wished', list.indexOf(b.getAttribute('data-wish-handle')) > -1);
    });
  }
  markWished();
  updateWishCount();

  /* ---------- Cart count + AJAX add ---------- */
  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.style.display = c.item_count ? 'grid' : 'none';
      });
    });
  }
  window.gpUpdateCartCount = updateCartCount;
  updateCartCount();

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-atc-variant]');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-atc-variant');
    var qtyEl = document.querySelector('[data-pp-qty]');
    var qty = btn.hasAttribute('data-atc-use-qty') && qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.classList.add('is-added');
      var old = btn.innerHTML;
      btn.innerHTML = '✓ Added to Cart';
      gpToast('🛒 Added to cart');
      updateCartCount();
      setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = old; btn.disabled = false; }, 1800);
    }).catch(function () {
      btn.disabled = false;
      gpToast('Could not add — please try again');
    });
  });

  /* ---------- Qty +/- ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-qty-change]');
    if (!b) return;
    var input = document.querySelector('[data-pp-qty]');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-qty-change'));
    input.value = Math.max(1, v);
  });

  /* ---------- Predictive search ---------- */
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    var panel = form.parentElement.querySelector('[data-search-suggest]');
    if (!input || !panel) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { panel.classList.remove('is-open'); return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { panel.classList.remove('is-open'); return; }
            panel.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=88" alt="">' : '';
              return '<a href="' + p.url + '">' + img + '<span><span class="s-title">' + p.title + '</span><br><span class="s-price">' + p.price + '</span></span></a>';
            }).join('');
            panel.classList.add('is-open');
          }).catch(function () {});
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!form.parentElement.contains(e.target)) panel.classList.remove('is-open');
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', function (ev) {
    var th = ev.target.closest('[data-thumb-src]');
    if (!th) return;
    var main = document.querySelector('[data-gallery-main] img');
    if (main) main.src = th.getAttribute('data-thumb-src');
    document.querySelectorAll('[data-thumb-src]').forEach(function (x) { x.classList.remove('is-active'); });
    th.classList.add('is-active');
  });

  /* ---------- Collection sort ---------- */
  var sortSel = document.querySelector('[data-sort-by]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Wishlist page render ---------- */
  var wishGrid = document.querySelector('[data-wishlist-grid]');
  if (wishGrid) {
    var handles = getWish();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!handles.length) {
      if (empty) empty.style.display = 'block';
    } else {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products.filter(Boolean).forEach(function (p) {
          var img = (p.images && p.images[0]) ? p.images[0] : '';
          var price = '₹' + (p.price / 100).toLocaleString('en-IN');
          var card = document.createElement('div');
          card.className = 'product-card';
          card.innerHTML =
            '<div class="product-card__media"><a href="' + p.url + '"><img src="' + img + '" alt=""></a>' +
            '<button class="wish-btn is-wished" data-wish-handle="' + p.handle + '" aria-label="Remove"><svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></button></div>' +
            '<div class="product-card__info"><div class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></div>' +
            '<div class="price-row"><span class="price">' + price + '</span></div>' +
            '<button class="product-card__atc" data-atc-variant="' + p.variants[0].id + '">Add to Cart</button></div>';
          wishGrid.appendChild(card);
        });
      });
    }
  }
})();
